<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { HistoryIcon } from '@solar-icons/vue/linear'
import AppDisclosure from '../../primitives/AppDisclosure/AppDisclosure.vue'
import AppRevisionHistory from '../../primitives/AppRevisionHistory/AppRevisionHistory.vue'
import type { ContentRevision } from '../../../types/content'

withDefaults(
  defineProps<{
    /** The post's versions, oldest first. */
    revisions: ContentRevision[]
    /** The version the post shows now. */
    currentRevisionId?: string
    loading?: boolean
  }>(),
  { currentRevisionId: undefined, loading: false },
)

const emit = defineEmits<{
  restore: [revisionId: string]
}>()

const { t } = useI18n()
</script>

<template>
  <AppDisclosure v-if="loading || revisions.length">
    <template #summary>
      <HistoryIcon class="shrink-0 text-icon-tertiary" />
      <p class="text-caption text-text-tertiary">
        {{ t('calendar.dock.history', { count: revisions.length }, revisions.length) }}
      </p>
    </template>
    <AppRevisionHistory
      :revisions="revisions"
      :current-revision-id="currentRevisionId"
      :loading="loading"
      @restore="(revisionId) => emit('restore', revisionId)"
    />
  </AppDisclosure>
</template>
